module.exports = __webpack_public_path__ + "img/img_side_doublecross.d3298f98.png";